'use strict';

function isAbsoluteUrl(url) {
	var absolute = false;
	if (url) {
		if (url.indexOf('http') === 0) {
			absolute = true;
		} else if (url.indexOf('//') === 0) {
			absolute = true;
		}
	}
	return absolute;
}

function scheduleTitleSearchUrl(title){
	return "//www.svt.se/tv-tabla/?query=" + encodeURIComponent(title) + "&titlesearch=true";
}

function faqTitleSearchUrl(title){
	return "//www.svt.se/tittarservice/fraga-oss/?tag=program&q=" + encodeURIComponent(title);
}

function articleTitleSearchUrl(title){
	return "//www.svt.se/search/?q=" + encodeURIComponent(title);
}
/*
DON'T USE THIS, USE SVTLink Button instead. 
function hostAwareUrl(env, url) {
	const host = env.get('HOST');
	if(host.indexOf('svt.se') === -1) {
		return "//www.svt.se" + url;
	} else {
		return url;
	}
}
*/
module.exports = {
	isAbsoluteUrl: isAbsoluteUrl,
	scheduleTitleSearchUrl: scheduleTitleSearchUrl,
	faqTitleSearchUrl: faqTitleSearchUrl,
	articleTitleSearchUrl: articleTitleSearchUrl
};



/** WEBPACK FOOTER **
 ** ./app/utils/urlUtils.js
 **/